import React from "react";
import loader from "../../components/loader/loader";
const ViewService = ({viewDetails,modalId}) => {
  const service = viewDetails ? viewDetails : "";

  return (
    <React.Fragment>
      <div
        className="modal fade"
        id={modalId}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body pt-0">
              <div className="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
                {viewDetails && service?._id ? (
                  <form
                    id="kt_modal_new_target_form"
                    className="form fv-plugins-bootstrap5 fv-plugins-framework"
                  >
                    <div className="mb-8 text-center">
                      <h1 className="mb-3 text-primary">Service Detail</h1>
                    </div>
                    <div className="separator d-flex flex-center mb-8"></div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Service Name </span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {service.name}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Price</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {service.price}
                        </div>
                      </div>
                    </div>

                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Detail</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {service.detail}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Tooltip</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {service.tooltip}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Sub Service Price</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {service.subServeicePrice}
                        </div>
                      </div>
                    </div>
                  </form>
                ) : 
                  <div className="spinner-outer p-5">
                    {loader()}
                  </div>
                  }
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ViewService;
